"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
// MONITOR TRACE VARIATIONS: the facilitator's choices for how the traces LOOK, shown inside the
// controller's Heart rate, SpO2 and Blood pressure windows (tap the tile).
//
//   - ECG: patient movement, mains interference, shivering / tremor, lead off
//   - Pleth: normal, poor peripheral perfusion, motion artefact, respiratory swing
//   - Arterial line: normal, overdamped, underdamped, respiratory swing, and a fast-flush test
//
// They live in state.noise (sim.setNoise), which already reaches every patient screen and the
// defib tablet, and is free-form in the database rules: no rules change. The drawing is in
// ECGMonitor (data/components.js) and the shapes in data/rhythms.js. The patient's true obs never
// change; only a damped arterial line shows wrong numbers, as a real one does.
(function () {
  var chip = function chip(on) {
    return "p-2 rounded border text-xs font-bold leading-tight ".concat(on ? 'bg-sky-600 border-sky-500 text-white' : 'bg-slate-700 border-slate-600 text-slate-300');
  };
  var label = 'text-xs text-slate-400 font-bold uppercase mb-2 block';
  var hint = 'text-[10px] text-slate-400 mt-2 leading-relaxed';
  var ECG = [['movement', 'Movement', 'Patient movement: large irregular baseline swings.'], ['interference', 'Mains', 'Mains (50 Hz) interference: a thick, fuzzy line.'], ['tremor', 'Shivering / tremor', 'Shivering or tremor: fast irregular oscillation that can look like flutter waves or VF.'], ['leadoff', 'Lead off', 'A lead off: a flat line on the monitor ECG with CHECK LEADS. Defib pads are not affected.']];
  var PLETH = [['normal', 'Normal', 'A normal pulse wave with a dicrotic notch.'], ['poor', 'Poor perfusion', 'Poor peripheral perfusion (cold, shut down, vasoconstricted): a small, rounded, noisy wave. The SpO2 number is unchanged; set it separately if you want it unreliable.'], ['motion', 'Motion artefact', 'A moving or shivering hand: large irregular swings swamp the pulse.'], ['swing', 'Resp. swing', 'Respiratory swing: the pulse height rises and falls with each breath (e.g. hypovolaemia on a ventilator).']];
  var ART = [['normal', 'Normal', 'An optimally damped arterial trace.'], ['overdamped', 'Overdamped', 'Overdamped (air bubble, clot, kinked line, soft bag): blunted, slurred wave, no dicrotic notch. Reads about 16 mmHg low systolic and 8 high diastolic; MAP unchanged.'], ['underdamped', 'Underdamped', 'Underdamped (long or stiff tubing, resonance): tall narrow spike with ringing. Reads about 20 mmHg high systolic and 10 low diastolic; MAP unchanged.'], ['swing', 'Resp. swing', 'Respiratory swing: systolic pressure varies with each breath (pulse pressure variation, e.g. hypovolaemia).']];
  var TraceVariations = function TraceVariations(_ref) {
    var kind = _ref.kind,
      sim = _ref.sim,
      noise = _ref.noise,
      hasArt = _ref.hasArt,
      hasSpo2 = _ref.hasSpo2,
      hasEcg = _ref.hasEcg;
    var n = noise || {};
    var set = function set(patch) {
      return sim.setNoise(patch);
    };
    if (kind === 'hr') {
      return /*#__PURE__*/React.createElement("div", {
        "data-testid": "trace-ecg"
      }, /*#__PURE__*/React.createElement("label", {
        className: label
      }, "ECG artefact"), /*#__PURE__*/React.createElement("div", {
        className: "grid grid-cols-2 gap-2"
      }, ECG.map(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 3),
          k = _ref3[0],
          txt = _ref3[1],
          title = _ref3[2];
        return /*#__PURE__*/React.createElement("button", {
          key: k,
          type: "button",
          "data-trace": "ecg-".concat(k),
          "aria-pressed": !!n[k],
          title: title,
          onClick: function onClick() {
            return set(_defineProperty({}, k, !n[k]));
          },
          className: chip(!!n[k])
        }, txt);
      })), /*#__PURE__*/React.createElement("div", {
        className: hint
      }, "Shown on the monitor ECG, your strip and the defib.", hasEcg ? '' : ' ECG leads are not attached yet.'));
    }
    if (kind === 'spO2') {
      var cur = n.pleth || 'normal';
      var sel = PLETH.find(function (p) {
        return p[0] === cur;
      }) || PLETH[0];
      return /*#__PURE__*/React.createElement("div", {
        "data-testid": "trace-pleth"
      }, /*#__PURE__*/React.createElement("label", {
        className: label
      }, "Pleth trace"), /*#__PURE__*/React.createElement("div", {
        className: "grid grid-cols-2 gap-2"
      }, PLETH.map(function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 3),
          k = _ref5[0],
          txt = _ref5[1],
          title = _ref5[2];
        return /*#__PURE__*/React.createElement("button", {
          key: k,
          type: "button",
          "data-trace": "pleth-".concat(k),
          "aria-pressed": cur === k,
          title: title,
          onClick: function onClick() {
            return set({
              pleth: k
            });
          },
          className: chip(cur === k)
        }, txt);
      })), /*#__PURE__*/React.createElement("div", {
        className: hint
      }, sel[2], hasSpo2 ? '' : ' The SpO2 probe is not attached yet.'));
    }
    if (kind === 'bp') {
      var _cur = n.art || 'normal';
      var _sel = ART.find(function (p) {
        return p[0] === _cur;
      }) || ART[0];
      return /*#__PURE__*/React.createElement("div", {
        "data-testid": "trace-art"
      }, /*#__PURE__*/React.createElement("label", {
        className: label
      }, "Arterial line trace"), /*#__PURE__*/React.createElement("div", {
        className: "grid grid-cols-2 gap-2"
      }, ART.map(function (_ref6) {
        var _ref7 = _slicedToArray(_ref6, 3),
          k = _ref7[0],
          txt = _ref7[1],
          title = _ref7[2];
        return /*#__PURE__*/React.createElement("button", {
          key: k,
          type: "button",
          "data-trace": "art-".concat(k),
          "aria-pressed": _cur === k,
          title: title,
          onClick: function onClick() {
            return set({
              art: k
            });
          },
          className: chip(_cur === k)
        }, txt);
      })), /*#__PURE__*/React.createElement("button", {
        type: "button",
        "data-trace": "art-flush",
        disabled: !hasArt,
        onClick: function onClick() {
          return set({
            artFlush: true
          });
        },
        title: "Fast-flush (square wave) test: the trace jumps off the scale, then drops back. Normal: 1 to 2 oscillations. Overdamped: a slow return with none. Underdamped: several.",
        className: "mt-2 w-full p-2 rounded border text-xs font-bold ".concat(hasArt ? 'bg-red-900/50 border-red-600 text-red-100 hover:bg-red-800/60' : 'bg-slate-800 border-slate-700 text-slate-500 cursor-not-allowed')
      }, "Flush test"), /*#__PURE__*/React.createElement("div", {
        className: hint
      }, _sel[2], hasArt ? ' Flush test shows how the line is damped.' : ' Attach an arterial line to see this trace.'));
    }
    return null;
  };
  window.TraceVariations = TraceVariations;
})();